import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

interface StateFieldProps {
  value: string;
  searchText?: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
  classes?: Record<string, string>;
  error?: string;
}

export default function StateField({
  value,
  searchText,
  onChange,
  classes = {},
  error,
}: StateFieldProps) {
  return (
    <Autocomplete
      disableClearable
      value={value}
      options={states}
      classes={classes}
      fullWidth
      getOptionLabel={(options) => options}
      renderInput={(params) => (
        <TextField
          {...params}
          required
          fullWidth
          label="State"
          variant="outlined"
          value={searchText}
          helperText={error}
          error={!!error}
          sx={{ bgcolor: 'white' }}
        />
      )}
      onChange={(event, newValue) => {
        onChange({
          target: {
            name: "state",
            value: newValue || "",
          },
        });
      }}
    />
  );
}
const states = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];
